import React, { useState } from 'react'
import search from "../Images/Home_Page/search.png"
import { FaAngleRight } from 'react-icons/fa'
import { BsFacebook } from 'react-icons/bs'
import { BsInstagram } from 'react-icons/bs'
import { BsTwitter } from 'react-icons/bs'
import { BsWhatsapp } from 'react-icons/bs'
import { BsYoutube } from 'react-icons/bs'



function ContactSection() {
    const [person, setPerson] = useState({userName: '', email: '', password: ''});

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setPerson({...person, [name]: value});
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        alert('Done ✅')  
    }
  return (
    <>
    <section className='sect'>
        <article>
            <h2 className='conv-text'>Let's start a conversation</h2>
            <form className='last-form' action="">
            <input className='search-bar2' type="text" placeholder='Search' />
            <button className='btn'><img src={search} alt="" /></button>
        </form>
        </article>
    </section>

        <div className='sectbox'>

                <div className='cont--box'>
                <form className='form2'  action="">
                    <div className='form-control'>
                    <label htmlFor="userName">Username</label>
                    <input className='form'
                        type="text"
                        id='userName'
                        name='userName'
                        value={person.userName} 
                        onChange={handleChange}
                    />
                </div>
                
                <div className='form-control'>
                <label htmlFor="email">Email</label>
                <input className='form'
                    type="email" 
                    id='email'
                    name='email'
                    value={person.email}
                    onChange={handleChange}
                />
                </div>

                <div className='form-control'>
                <label htmlFor="password">Password</label>
                <input className='form'
                    type="password" 
                    id='password'
                    name='password'
                    value={person.password}
                    onChange={handleChange}
                />
                </div>

                <button className='submit' onSubmit={handleSubmit}>
                    Sign Up 
                    <FaAngleRight className='arrow' />
                </button>
            </form>
            </div>

           
            `<div className='vl2'>
                <div className='info-bg'>
                <h3 className='info1'>INFORMATION</h3>
                <p className='info2'>Pricing - About Us - Business FAQs</p>
                </div>
            </div>

            <div className='vl3'>
                <h4 className='soc'>Social Media</h4>
                <BsFacebook className='s-icon'/>
                <BsInstagram className='s-icon'/>
                <BsTwitter className='s-icon'/>
                <BsWhatsapp className='s-icon'/>
                <BsYoutube className='s-icon'/>
            </div>
           
            
        </div>       
        
   

    </>
  )
}

export default ContactSection